import { SidebarHeader } from "@/@types/dtos/sidebar.types";
import { routes } from "@/presentation/router";

export const SidebarMenu: SidebarHeader[] = [
  {
    paths: [
      {
        name: "Dashboard",
        to: routes.home.path,
        icon: "fa-solid fa-chart-simple",
        permission: 'dashboard:view'
      },
    ],
  },
  {
    header: "Recargas",
    paths: [
      {
        name: "Sessões",
        to: routes.sessions.path,
        icon: "fa-solid fa-plug",
        permission: 'chargings:list'
      },
      {
        name: "Usuários",
        to: routes.users.path,
        icon: "fa-solid fa-users",
        permission: 'users:list'
      },
    ],
  },
  {
    header: "Cadastros",
    paths: [
      {
        name: "Localidades",
        to: routes.locations.path,
        icon: "fa-solid fa-location-dot",
        permission: 'locations:list'
      },
      {
        name: "Carregadores",
        to: routes.chargers.path,
        icon: "fa-solid fa-charging-station",
        permission: 'chargers:list'
      },
      {
        name: "Planos",
        to: routes.plans.path,
        icon: "fa-solid fa-cubes",
        permission: 'plans:list'
      },
      {
        name: "Parcerias",
        to: routes.partnerships.path,
        icon: "fa-solid fa-handshake",
        permission: 'partnership:list'
      },
    ],
  },
  {
    header: "Gestão",
    paths: [
      {
        name: "Administradores",
        to: routes.admins.path,
        icon: "fa-solid fa-user-gear",
        permission: 'admins:list'
      },
    ],
  },
];
